import React from 'react';
import { Well } from 'react-bootstrap';
import { Field, reduxForm, reset, SubmissionError } from 'redux-form';
import * as actions  from './../../../actions/featureClassActions';
import axios from './../../../constants/axios';
import alert from 'alertify.js';

import InputControl from './../../FormTemplate/InputControl';

class FeatureForm extends React.Component {

   saveNewFeature = (feature) => {
      const { featureClassId } = this.props;
      // const data = Object.assign({}, feature, {
      //    feature_class_id: featureClassId
      // });
      return axios.post(`featureClasses/${featureClassId}/feature`, feature)
         .then((res) => {
            if (res.status === 201) {
               alert.success('Feature Created.');
               this.props.dispatch(actions.saveNewFeatureSuccess({
                  featureClassId,
                  feature
               }));
               this.props.dispatch(reset('newFeature'));
            } else {
               alert.error('Critical Error. Call Admin.');
            }
         })
         .catch((err) => {
            if (err.response.status === 422) {
               throw new SubmissionError(err.response.data);
            } else {
               alert.error('UnExpected error. Call Admin.');
            }
         });
   };

   render() {
      const { handleSubmit } = this.props;
      return (
         <Well>
            Create New Feature
            <form noValidate autoComplete="off" onSubmit={handleSubmit(this.saveNewFeature)} >
               <Field name="name" type="text" component={InputControl} />
               <button type="submit" >Save</button>
            </form>
         </Well>
      );
   }
}

FeatureForm.propTypes = {
   handleSubmit: React.PropTypes.func,
   saveNewFeatureClass: React.PropTypes.func,
   dispatch: React.PropTypes.func,
   featureClassId: React.PropTypes.number
};

export default reduxForm({
   form: 'newFeature'
})(FeatureForm);



/** WEBPACK FOOTER **
 ** ./src/components/ItemManagement/FeatureClass/FeatureForm.js
 **/